export default __webpack_public_path__ + "static/media/logo.10a608b1.png";